const breakpoints = {
    minDesktop: window.matchMedia('screen and (min-width: 1440px)'),
    tabletMin: window.matchMedia('screen and (min-width: 992px)'),
    tabletMax: window.matchMedia('screen and (max-width: 991px)'),
    mobileMin: window.matchMedia('screen and (min-width: 768px)'),
    mobileMax: window.matchMedia('screen and (max-width: 767px)'),
    lgMax: window.matchMedia('screen and (max-width: 1199px)'),
    lgMin: window.matchMedia('screen and (min-width: 1200px)'),
};

export default breakpoints;
